import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { translationHookOptions } from "../../app/localization/localization";
import { ITenant } from "../../app/models/tenant";
import { RootStoreContext } from "../../app/stores/rootStore";
import SidebarGenericButton from "./SidebarGenericButton";

interface IParams {
  tenant: ITenant;
  currentUrl?: string;
}

const SidebarArchiveButton: React.FC<IParams> = ({ tenant, currentUrl }) => {
  const rootStore = useContext(RootStoreContext);
  const { currentTenant } = rootStore.tenantStore;
  const { enabledArchiveButton } = rootStore.playerStore;
  const {isMobileMediaQuery,setIsSidebarModalOpen} = rootStore.responsiveStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  return (
    <>
      {enabledArchiveButton ? (
        <div className={classNames(isMobileMediaQuery? "col-6 mobileSidebarButtonContainer" : "", "pt-0 pb-0")}>
          <Link to={`${currentTenant!.path}/archives`} className=" pb-0">
            <SidebarGenericButton
              icon={"fas fa-archive text"}
              label={t("sidebar_btn_archive")}
              isActive={currentUrl === `${tenant.path}/archives`}
              onClick={()=> isMobileMediaQuery && setIsSidebarModalOpen(false)}
              />
          </Link>
        </div>
      ) : null } 
    </>
  );
};

export default observer(SidebarArchiveButton);
